
const featuresModal = document.querySelector('.features-modal-outer');

if ( featuresModal ) {

    let isActive = false;
    document.body.addEventListener('click', (e) => {
        const target = e.target;
        
        if ( target.closest('[open-features-modal]') || target.closest('[href="#open-features-modal"]') ) {
            e.preventDefault();
            featuresModal.classList.add('modal-open');
            // console.log('🚀🚀🚀 Clicked features trigger!');
            
            if ( !isActive ) {
                isActive = true;
                const swiperFeaturesModal = new window.swiper('.features-modal-usp-slider.swiper', {
                    slidesPerView: 1.25,
                    spaceBetween: 22,
                    
                    breakpoints: {
                        576: {
                            slidesPerView: 1.8,
                        },
                        768: {
                            slidesPerView: 2.5,
                        },
                        992: {
                            slidesPerView: 3.5,
                        }
                    },
                    
                });
                
            }
            
            
        } else if ( target.closest('[close-features-modal]') || target.classList.contains('features-modal-outer') ) {
            featuresModal.classList.remove('modal-open');
            // console.log('🚀🚀🚀 Clicked features close!');
        }
        
    });
    
    
    
}